// extracted by mini-css-extract-plugin
export default {"content":"Hero__content-WZpz","title":"Hero__title-xNC8","eyebrow":"Hero__eyebrow-Y0ij","desc":"Hero__desc-tV_r","heroSection":"Hero__heroSection-GQiC"};